/** All valid PromptPurpose enum values from the API */
export type PromptPurpose =
  | 'attraction_short_description'
  | 'attraction_long_description'
  | 'tour_content'
  | 'tour_conclusions'
  | 'themed_short_description'
  | 'themed_long_description'
  | 'attraction_metadata'
  | 'attraction_list'
  // Deprecated — kept for backward compatibility with old records
  | 'attraction_descriptions'
  | 'themed_descriptions';

interface PurposeConfig {
  label: string;
  /** Tailwind classes for background, text and border colors */
  className: string;
}

export const PURPOSE_CONFIG: Record<string, PurposeConfig> = {
  attraction_short_description: {
    label: 'Attraction Short Description',
    className: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  attraction_long_description: {
    label: 'Attraction Long Description',
    className: 'bg-sky-100 text-sky-800 border-sky-200',
  },
  attraction_descriptions: {
    label: 'Attraction Descriptions',
    className: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  tour_content: {
    label: 'Tour Content',
    className: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  },
  tour_conclusions: {
    label: 'Tour Conclusions',
    className: 'bg-teal-100 text-teal-800 border-teal-200',
  },
  themed_short_description: {
    label: 'Themed Short Description',
    className: 'bg-purple-100 text-purple-800 border-purple-200',
  },
  themed_long_description: {
    label: 'Themed Long Description',
    className: 'bg-violet-100 text-violet-800 border-violet-200',
  },
  themed_descriptions: {
    label: 'Themed Descriptions',
    className: 'bg-purple-100 text-purple-800 border-purple-200',
  },
  attraction_metadata: {
    label: 'Attraction Metadata',
    className: 'bg-amber-100 text-amber-800 border-amber-200',
  },
  attraction_list: {
    label: 'Attraction List',
    className: 'bg-rose-100 text-rose-800 border-rose-200',
  },
};

/**
 * Returns the human-readable label for a given PromptPurpose.
 *
 * @param purpose - The purpose enum value.
 * @returns The display label string.
 */
export function getPromptPurposeLabel(purpose: string): string {
  return PURPOSE_CONFIG[purpose]?.label ?? purpose;
}

/** All purpose options formatted for select inputs (active purposes only) */
export const PROMPT_PURPOSE_OPTIONS: Array<{ label: string; value: PromptPurpose }> = [
  { label: 'Attraction Short Description', value: 'attraction_short_description' },
  { label: 'Attraction Long Description', value: 'attraction_long_description' },
  { label: 'Tour Content', value: 'tour_content' },
  { label: 'Tour Conclusions', value: 'tour_conclusions' },
  { label: 'Themed Short Description', value: 'themed_short_description' },
  { label: 'Themed Long Description', value: 'themed_long_description' },
  { label: 'Attraction Metadata', value: 'attraction_metadata' },
];
